import { LoadingSpinner } from '@simplywallst/ui-core';
import { ReactNode } from 'react';
import Link from 'redux-first-router-link';
import { tv } from 'tailwind-variants';

type Props = {
  children: ReactNode;
  to: string;
  onClick: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
  rel?: string;
};

const button = tv({
  base: [
    'no-underline',
    'text-brand-01',
    'text-xs',
    'grid',
    'items-center',
    'place-content-center',
    'justify-between',
    'bg-brand',
    'rounded-x0_75',
    'gap-x1',
    'px-x1_5',
    'h-x5',
    'bg-brand-03-subtle',
    'grid-cols-[auto_auto_auto]',
    'border',
    'border-p-white-100/5',
    'transition-colors',
    'transifion-opacity',
    'hover:bg-p-blue-120/20',
    'focus:outline-dashed',
    'focus:outline-1',
    'focus:outline-offset-[3px]',
    'focus:outline-p-blue-100',
  ],
  variants: {
    isDisabled: {
      true: 'opacity-40 cursor-not-allowed pointer-events-none',
    },
  },
});

export const NarrativeCommunityListPaginationButton = ({
  to,
  children,
  onClick,
  isDisabled,
  isLoading,
  rel,
}: Props) => {
  return (
    <Link
      aria-disabled={isDisabled}
      to={to}
      tabIndex={isDisabled ? -1 : 0}
      onClick={(e) => {
        if (isDisabled) {
          e.preventDefault();
          return;
        }
        onClick();
      }}
      className={button({ isDisabled })}
      rel={rel}
    >
      {children}
      {isLoading && (
        <LoadingSpinner aria-label="Loading indicator" styleType="light" />
      )}
    </Link>
  );
};
